// extracted by mini-css-extract-plugin
export var button = "_jc-2";
export var card = "_jc-0";
export var closeButtonContainer = "_jc-3";
export var iconContainer = "_jc-1";